export const replaceSpaceWithUnderscore = (text?: string) => {
  if (!text) return ''

  return text.trim().replace(/\s/g, '_')
}
